import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useParams,
} from 'react-router-dom'
import { WavePlanErrorBoundary } from '@/components/WavePlanning/WavePlanErrorBoundary'
import { wavePlanPath } from '@/components/WavePlanning/routes'
import WavePlanning from '@/pages/WavePlanning'
import WavePlanningDetail from '@/pages/WavePlanningDetail'
import WavePlanningDistributionCenters from '@/pages/WavePlanningDistributionCenters'
import WavePlanningRollup from '@/pages/WavePlanningRollup'
import WavePlans from '@/pages/WavePlans'

function ToPlanOverview() {
  const { planId = '' } = useParams()
  return <Navigate to={wavePlanPath(planId)} replace />
}

/** Wave planning pages (mounted at ``/wave-planning/*``). */
export default function WavePlanningRoutes() {
  const { pathname } = useLocation()
  return (
    // A new boundary per page, so an error on one view does not stick to the next.
    <WavePlanErrorBoundary key={pathname}>
      <Routes>
        <Route index element={<WavePlans />} />
        <Route path="rollup" element={<WavePlanningRollup />} />
        <Route path="plans/:planId" element={<WavePlanning />} />
        <Route path="plans/:planId/skus" element={<WavePlanningDetail />} />
        <Route
          path="plans/:planId/distribution-centers"
          element={<WavePlanningDistributionCenters />}
        />
        <Route path="plans/:planId/*" element={<ToPlanOverview />} />
        <Route path="*" element={<Navigate to="/wave-planning" replace />} />
      </Routes>
    </WavePlanErrorBoundary>
  )
}
